function addCartDrawerFormEventListeners() {
  //close cart drawer
  document
    .querySelectorAll('#close-cart-drawer, #cart-drawer-background')
    .forEach((element) => {
      element.addEventListener('click', function () {
        document.getElementsByTagName('html')[0].classList.remove('cart-open')
      })
    })

  customInputNumberListeners(
    document.querySelector('.cart-drawer form[action="/cart"]')
  )

  //update quanity when value is changed
  document
    .querySelectorAll(
      '.cart-drawer form[action="/cart"] .input-number-wrapper input'
    )
    .forEach((input) => {
      input.addEventListener('change', async function () {
        const key = input
          .closest('[data-item-key]')
          .getAttribute('data-item-key')
        updateCartDrawerQuantityDebounced(key, this.value) //debounce call to update with API
      })
    })

  //remove item, by setting quantity to 0
  document
    .querySelectorAll('.cart-drawer form[action="/cart"] button.remove')
    .forEach((button) => {
      button.addEventListener('click', async function () {
        const key = button
          .closest('[data-item-key]')
          .getAttribute('data-item-key')
        updateCartDrawerQuantityDebounced(key, 0) //debounce call to update with API
      })
    })

  const signInButton = document.querySelector('.cart-drawer button#sign-in')
  if (signInButton) {
    signInButton.addEventListener('click', function () {
      document.querySelector('a#login-and-return-to-page').click()
      sessionStorage.setItem('open-cart-drawer', 'true')
      sessionStorage.setItem('redirect-to', `${window.location.pathname}`)
    })
  }

  const joinNowButton = document.querySelector('.cart-drawer a.join-now')
  if (joinNowButton) {
    joinNowButton.addEventListener('click', function (event) {
      event.preventDefault()
      sessionStorage.setItem('open-cart-drawer', 'true')
      sessionStorage.setItem('redirect-to', `${window.location.pathname}`)
      const href = joinNowButton.getAttribute('href')
      window.location.href = href
    })
  }
}

if (document.querySelector('.cart-drawer form[action="/cart"]')) {
  addCartDrawerFormEventListeners() //init on first page load
  const url = new URL(window.location.href)
  const params = url.searchParams
  if (params.has('open_cart_drawer')) {
    setTimeout(() => {
      document.querySelector('button#open-cart-drawer').click()
    }, 100)
  }
}

async function updateCartDrawerQuantity(key, quantity) {
  const res = await fetch('/cart/update.js', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates: { [key]: quantity } })
  })

  updateCartDrawer()

  const cart = await res.json()
  updateHeaderCartCount(cart.item_count)
}

const updateCartDrawerQuantityDebounced = debounce((productKey, quantity) =>
  updateCartDrawerQuantity(productKey, quantity)
)

async function updateCartDrawer() {
  const cartDrawerElement = document.querySelector('.cart-drawer')
  if (!cartDrawerElement) return

  const res = await fetch('/?section_id=cart-drawer') //get section again that will contain the updated values
  const text = await res.text()
  //convert plain text to html
  const html = document.createElement('div')
  html.innerHTML = text

  const newBox = html.querySelector('.cart-drawer').innerHTML
  cartDrawerElement.innerHTML = newBox
  addCartDrawerFormEventListeners() //re-add event listeners once html has been replaced
}
